import { render, staticRenderFns } from "./Reserved.vue?vue&type=template&id=865ebe70&scoped=true"
import script from "./Reserved.vue?vue&type=script&lang=js"
export * from "./Reserved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865ebe70",
  null
  
)

export default component.exports